import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {getBodyStyleCategory} from '../../../../../../../utils/getBodyStyleCategory';
import {VehicleCategoryFilter} from '../../../../../types/VehicleCategoryFilter';
import {useFilters} from '../../../../FiltersContext/FiltersContext';

export function useChangeVehicleCategory() {
  const {filters, onUpdateFilters} = useFilters();
  return (nextCategory: VehicleCategoryFilter | null) => {
    onUpdateFilters('vehicleCategory', nextCategory);

    if (isNil(nextCategory)) {
      return;
    }

    // Only clear what is set: every `onUpdateFilters` call also pushes a filter_changed GTM event.
    if (nextCategory === VehicleCategoryFilter.CAR) {
      if (isNotNilOrEmpty(filters.vehicleLengthCategory)) {
        onUpdateFilters('vehicleLengthCategory', undefined);
      }
      if (isNotNilOrEmpty(filters.vehicleHeightCategory)) {
        onUpdateFilters('vehicleHeightCategory', undefined);
      }
    }

    const bodyTypeInCategory = filters.bodyType?.filter(
      (key) => getBodyStyleCategory(key) === nextCategory
    );
    if (bodyTypeInCategory?.length !== filters.bodyType?.length) {
      onUpdateFilters('bodyType', bodyTypeInCategory?.length ? bodyTypeInCategory : undefined);
    }
  };
}
